import { Text } from '@chakra-ui/layout'
import { dateTHHMS, dateTH } from '../../utils/dateUtils'

const TextDateFormat = ({ value, full, datetime = true, ...rest }) => {
    return (
        <Text {...rest}>{(datetime ? dateTHHMS(value, full) : dateTH(value, full)) || "-"}</Text>
    )
}

export default TextDateFormat
